import { INotificationFilter } from "@/features/notification/notification.types";
import { http } from "@/utils/http";
import { cleanParams } from "@/utils/cleanParams";
import { AxiosResponse } from "axios";

export const notificationService = {
  getList: async (filter: INotificationFilter): Promise<AxiosResponse> => {
    return http.get("/notifications", {
      params: cleanParams(filter),
    });
  },

  notificationCount: async (): Promise<AxiosResponse> => {
    return http.get("/notifications/unread-count");
  },

  readAll: async (): Promise<AxiosResponse> => {
    return http.patch("/notifications/read-all", {});
  },

  readNotification: async (id: string): Promise<AxiosResponse> => {
    return http.patch(`/notifications/${id}/read`, {});
  },

  createNotification: async (): Promise<AxiosResponse> => {
    return http.post("/notifications/test", {});
  },
};
